import React from 'react';
import { connect } from 'react-redux';
import * as movieActions from 'ducks/movie';
import * as serieActions from 'ducks/serie';
import { AppState } from 'store/rootReducer';
import { push } from 'connected-react-router';
import {Layout} from 'components/Layout';
import styles from './Home.module.scss';
import {Box} from 'components/Box';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import YoutubeModal from 'components/YoutubeModal/YoutubeModal';
import { useStore } from 'contexts/store';
import { RouteComponentProps } from 'react-router';
import {  
      SET_CURRENT_MOVIE, 
      SET_MOVIES,
      SET_SERIES, 
      SET_CURRENT_SERIE,
      SET_CURRENT_TRAILER
  } from 'constants/store';
import { services } from 'globals/app';
import useClickAway  from 'hooks/useClickAway';
import { AxiosResponse } from 'axios';
import { PopularMoviesResponse } from 'types/api';
import useInfiniteScroll from 'hooks/useInfiniteScroll';


/**
 * Home is the root component of the app and 
 * renders all movies & search bar.
 * @param {object} history
 * @return {*}
 * @final
*/
const Home: React.FC<RouteComponentProps> = (props) : JSX.Element  => {
  let [modal, setModal] = React.useState(false);
  const clickRef = React.useRef("");
  let { state, dispatch } = useStore();
  let MOVIES = state.movies;
  let SERIES = state.series;
  const history = useHistory();
  const [hasMore, setHasMore] = React.useState(false);
  const [page, loaderRef, scrollerRef] = useInfiniteScroll({ hasMore });

  React.useEffect(() => {
        let payload = {
           range: 'day',
           page: 1
        };
        
        props.getCategories();
        props.getSeries(payload);
  },[]);

  React.useEffect(() => {
      const realPage = page + 1;
     services.movie.getTrendingMovies('day', realPage)
       .then((movies:AxiosResponse<PopularMoviesResponse>) =>   {
           if(page === 100) {
             setHasMore(false);
           } else {
             setHasMore(true);
           }
          
          dispatch({ type: SET_MOVIES ,movies: [...state.movies, ...movies.data.results] })
       });
  }, [page]);

  useClickAway(clickRef, () => {
     setModal(false);
  });

  const goTo = (route: string) => {
        history.push(route);
        window.scrollTo(0, 0);
  };

  const handleClick = (movie: any, type: string) : void => {
    if( type === 'story') {
       setModal(true);
       dispatch({ type:SET_CURRENT_SERIE,serie:movie });
    } else {
      goTo(`/watch/${movie.id}`);
      dispatch({ type:SET_CURRENT_MOVIE,movie:movie });
    }
    dispatch({ type:SET_CURRENT_TRAILER,trailer:type });
};
     
  return (
     <Layout>
         <Grid ref={clickRef} container spacing={2}>
             <Grid item xs={12}>

            <Grid  className={styles.storyContainer} wrap="nowrap" container  spacing={10}>
              {props.series.map((movie: any, index: number) => (
                <Grid key={index} item className={styles.serie}>
                    <Box  
                      title={movie.title}
                      poster_path={movie.poster_path} 
                      onClick={() => handleClick(movie,'story')}
                      type={'story'}
                    />
                </Grid>
              ))}
            </Grid>

            <Grid  ref={scrollerRef} className={styles.allContainer} container justify="center" spacing={10}>
              {MOVIES.map((movie: any, index: number) => (
                <Grid key={index} item>
                    <Box 
                      adult={movie.adult}
                      backdrop_path={movie.backdrop_path}
                      genre_ids={movie.genre_ids}
                      id={movie.id}
                      original_language={movie.original_language}
                      original_title={movie.original_title}
                      overview={movie.overview}
                      popularity={movie.popularity}
                      poster_path={movie.poster_path}
                      release_date={movie.release_date}
                      title={movie.title}
                      video={movie.video}
                      vote_average={movie.vote_average}
                      vote_count={movie.vote_count}              
                      onClick={() => handleClick(movie, 'classic')}
                      showRating={true}
                      showTitle={true}
                      size={'small'}
                      type={'classic'}
                    />
                </Grid>
              ))}
              {hasMore && <div ref={loaderRef}></div>}
              </Grid>
            </Grid>
            {modal && <YoutubeModal modal={modal} setModal={setModal} />}
        </Grid>
     </Layout>
  );
};


const mapStateToProps = (state: AppState) => ({
  categories: state.movie.categories,
  series: state.serie.series,
});


const mapDispatchToProps = {
  push,
  getCategories: movieActions.getCategoriesAsync.request,
  getSeries: serieActions.getSerieAsync.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);